// import { Email } from './email';

export class Profile {
  company?: string;
  fullName: string;
  imageURL: string;
  username: string;
  bio?: string;
  url?: string;
  email?: string;
  emailPrivate?: boolean;
  cluster?: string;
}
